@if (animal && objectKeys(animal).length) {
  <p-panel>
    <div class="flex flex-wrap items-center">
      <div class="flex p-2">
        <i class="pi pi-angle-double-left cursor-pointer" style="color:#7e9c30;font-size: 2rem"
           (click)="goBack()"></i>
      </div>
      <div class="px-2">
        <app-animal-current-category [animal]="animal"></app-animal-current-category>
      </div>
      <div class="flex w-[5rem] h-[5rem] relative">
        <app-animal-image-container
          [animal]="animal"
          [preview]="true"
        />
      </div>
      <div class="flex px-2 animal-name-headline">
        <app-animal-in-stock-icon [animal]="animal"></app-animal-in-stock-icon>
        {{ animal.displayName }}
      </div>
      <div class="flex px-4 justify-center items-center">
        <img src="../../../../assets/images/icons/icon_key_green.svg" alt="key"
             [pTooltip]="previousBookNumbers"
             tooltipPosition="right"
             [tooltipDisabled]="previousBookNumbersWithShelter.length === 0"
        >
        <ng-template #previousBookNumbers>
          <div class="flex flex-col">
            <p>{{ 'animalDetails.general.header.previousBookNumbers' | transloco }}</p>
            @for (entry of previousBookNumbersWithShelter; track entry) {
              <p>
                {{ 'Buchnummer: ' + entry.bookNumber }}
                @if (entry.shelterName) {
                  <span>({{ entry.shelterName }})</span>
                }
              </p>
            }
          </div>
        </ng-template>
        <p>@if (animal.oldBookNumber) { {{ animal.oldBookNumber }} }
          <span>({{ animal.bookNumber }})</span>
        </p>
      </div>
      <div class="flex px-4">
        @if (fromOtherShelter) {
          <span class="info-badge"><i
            class="pi pi-info-circle"></i>{{ 'animalDetails.animalNotInShelter' | transloco }}</span>
        }
      </div>
      <div class="flex flex-1 gap-4 items-end justify-end justify-content-center">
        <div class="flex flex-col items-center">
          <label class="pb-2 text-xs" for="outdoor">{{ 'animalDetails.general.header.outdoor' | transloco }}</label>
          <p-toggleswitch
            [(ngModel)]="animal.outdoor"
            (onChange)="onOutdoorChange(animal.id, $event)"
            inputId="outdoor"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="pb-2 text-xs" for="sponsored">{{ 'animalDetails.general.header.sponsored' | transloco }}</label>
          <p-toggleswitch
            [(ngModel)]="animal.sponsored"
            (onChange)="onSponsoredChange(animal.id, $event)"
            inputId="sponsored"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="pb-2 text-xs" for="sanctuary">{{ 'animalDetails.general.header.sanctuary' | transloco }}</label>
          <p-toggleswitch
            [(ngModel)]="animal.sanctuary"
            (onChange)="onSanctuaryChange(animal.id, $event)"
            inputId="sanctuary"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="pb-2 text-xs"
                 for="fosterHomeWanted">{{ 'animalDetails.general.header.fosterHomeWanted' | transloco }}</label>
          <p-toggleswitch
            [(ngModel)]="animal.fosterHomeWanted"
            (onChange)="onFosterHomeWantedChange(animal.id, $event)"
            inputId="fosterHomeWanted"
          />
        </div>
        <div class="flex flex-col items-center">
          <label class="pb-2 text-xs"
                 for="syncWithWebsite">{{ 'animalDetails.general.header.syncWithWebsite' | transloco }}</label>
          <p-toggleswitch
            [(ngModel)]="animal.syncWithWebsite"
            (onChange)="onSyncWithWebsiteChange(animal.id, $event)"
            inputId="syncWithWebsite"
          />
        </div>
        <div class="flex items-center justify-center gap-1">
          <p-button (onClick)="menu.toggle($event)" icon="pi pi-ellipsis-v"/>
          <p-menu #menu [model]="animalEditMenuItems" [popup]="true" appendTo="body"/>
          <p-button
            (click)="toggleEditDialog()"
            icon="pi pi-pen-to-square"
          />
        </div>
      </div>
    </div>
    <p-tabs #animalTabsEl [value]="selectedTabIndex" (valueChange)="onTabOpenChange($event)">
      <p-tablist>
        <p-tab [value]="0">{{ 'animalDetails.general.headline' | transloco }}</p-tab>
        <p-tab [value]="1">{{ 'animalDetails.origin.headline' | transloco }}</p-tab>
        <p-tab [value]="2">{{ 'animalMedia.headline' | transloco }}</p-tab>
        <p-tab [value]="3">{{ 'animalNotes.headline' | transloco }}</p-tab>
        <p-tab [value]="4">{{ 'animalDetails.timeline.headline' | transloco }}</p-tab>
        <p-tab [value]="5">{{ 'animalDocuments.headline' | transloco }}</p-tab>
        <p-tab [value]="6" data-cy="animal-tab-medical">{{ 'animalMedical.headline' | transloco }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <div class="grid grid-cols-2 gap-2">
            <div>
              <p-accordion [multiple]="true" [value]="['0', '1']">
                <p-accordion-panel value="0">
                  <p-accordion-header>{{ 'animalDetails.general.basicData.headline' | transloco }}</p-accordion-header>
                  <p-accordion-content>
                    <div class="grid grid-cols-2 gap-2">
                                              <div>
                        <p class="field-title">{{ 'animalDetails.general.basicData.category' | transloco }}</p>
                        <p>{{ 'animal.category.' + animal.category | transloco }}</p>
                      </div>
                      <div>
                        <p class="field-title">{{ 'animalEdit.general.basicData.type' | transloco }}</p>
                        <p>{{ 'animal.type.' +  animal.type | transloco}}</p>
                      </div>
                      @if (animal.breed) {
                        <div class="col-span-2">
                          <p class="field-title">{{ 'animalDetails.general.specifications.breed' | transloco }}</p>
                          <p>{{ animal.breed }}</p>
                        </div>
                      }
                      @if (animal.nameOld) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.basicData.nameOld' | transloco }}</p>
                          <p>{{ animal.nameOld }}</p>
                        </div>
                      }
                      @if (animal.nameNew) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.basicData.nameNew' | transloco }}</p>
                          <p>{{ animal.nameNew }}</p>
                        </div>
                      }
                      @if (animal.motherId) {
                        <div class="col-span-2">
                          <p class="field-title">{{ 'animalDetails.general.basicData.mother' | transloco }}</p>
                          <div
                            class="flex no-underline"
                          >
                            <span class="w-10 h-[4rem] relative flex">
                              <app-animal-image-container
                                [animal]="motherAnimal"
                                [preview]="true"
                              />
                            </span>
                            <span class="flex items-center pl-4 cursor-pointer"
                                  [routerLink]="['/tiere', motherAnimal?.id]">
                              {{ motherAnimal?.displayName }}
                            </span>
                          </div>
                        </div>
                      }
                      @if (animal.sex) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.basicData.sex' | transloco }}</p>
                          <p>
                            <app-animal-sex-icon [animal]="animal"></app-animal-sex-icon>
                          </p>
                        </div>
                      }
                     <div>
                        <p
                          class="field-title">{{ 'animalDetails.general.specialInformations.castrated' | transloco }}</p>
                        @if (animal.castrated) {
                          <p>{{ 'yes' | transloco }}</p>
                        }
                        @if (!animal.castrated) {
                          <p>{{ 'no' | transloco }}</p>
                        }
                      </div>
                      @if (animal.castratedDate) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.castratedDate' | transloco }}</p>
                          <p>{{ animal.castratedDate | date: 'dd.MM.yyyy' }}</p>
                        </div>
                      }
                      @if (animal.chemicalCastratedDate) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.chemicalCastratedDate' | transloco }}</p>
                          <p>{{ animal.chemicalCastratedDate | date: 'dd.MM.yyyy' }}</p>
                        </div>
                      }
                      @if (animal.sterilizedDate) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.sterilizedDate' | transloco }}</p>
                          <p>{{ animal.sterilizedDate | date: 'dd.MM.yyyy' }}</p>
                        </div>
                      }
                      @if (animal.castratedNote) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.castratedNote' | transloco }}</p>
                          <p>{{ animal.castratedNote }}</p>
                        </div>
                      }

                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel value="1">
                  <p-accordion-header>{{ 'animalDetails.general.specifications.headline' | transloco }}</p-accordion-header>
                  <p-accordion-content>
                    <div class="grid grid-cols-2 gap-2">
                      @if (animal.birthYear || animal.birthday) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.specifications.birthday' | transloco }}</p>
                          @if (animal.birthApprox) {
                            <p class="inline mr-1">
                              {{ 'animalDetails.general.specifications.about' | transloco }}
                            </p>
                          }
                          @if (animal.birthYear) {
                            <p class="inline">{{ animal.birthYear | dateYear: 'yyyy' }}</p>
                          }
                          @if (animal.birthday) {
                            <p class="inline">{{ animal.birthday | date:'dd.MM.yyyy' }}</p>
                          }
                        </div>
                      }
                      @if (animal.birthPlace) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specifications.birthPlace' | transloco }}</p>
                          <p>{{ animal.birthPlace }}</p>
                        </div>
                      }
                      @if (animal.coatType.length) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.specifications.coatType' | transloco }}</p>
                          <p>
                            @for (coatType of filteredCoatTypes; track coatType; let isLast = $last) {
                              <span>
                                {{ 'animal.coatType.' + coatType | transloco }}
                                @if (!isLast) {
                                  ,
                                }
                              </span>
                            }
                          </p>
                        </div>
                      }
                      @if (animal.coatColor) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specifications.coatColor' | transloco }}</p>
                          <p>{{ animal.coatColor }}</p>
                        </div>
                      }
                      @if (animal.badge) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specifications.badge' | transloco }}</p>
                          <p>{{ animal.badge }}</p>
                        </div>
                      }
                      @if (animal.specialNotice) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specifications.specialNotice' | transloco }}</p>
                          <p>{{ animal.specialNotice }}</p>
                        </div>
                      }
                      @if (animal.size) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.specifications.size' | transloco }}</p>
                          <p>{{ (animal.size !== null ? animal.size / 10 : '') }} @if (animal.size !== null) {
                            <span
                            >cm</span>
                          }
                          </p>
                        </div>
                      }
                      @if (animal.weight) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.specifications.weight' | transloco }}</p>
                          <p>
                            {{ (animal.weight !== null ? (animal.weight / 1000) : '') | number:'1.0-3' }}
                            @if (animal.weight !== null) {
                              <span>kg</span>
                            }
                          </p>
                        </div>
                      }
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
              </p-accordion>
            </div>
            <div>
              <p-accordion [multiple]="true" [value]="['0', '1']">
                <p-accordion-panel value="0">
                  <p-accordion-header>{{ 'animalDetails.general.numbers.headline' | transloco }}</p-accordion-header>
                  <p-accordion-content>
                    <div class="grid grid-cols-2 gap-2">
                      @if (animal.oldBookNumberList?.length) {
                        <div>
                          <p class="field-title">
                            {{ 'animalAdd.general.basicData.oldBookNumber' | transloco }}
                          </p>
                          @for (oldBookNumber of oldBookNumberListReversed; track oldBookNumber) {
                            {{ oldBookNumber }}<br/>
                          }
                        </div>
                      }
                      @if (animal.transponderNumber?.length) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.numbers.transponderNumber' | transloco }}</p>
                          @for (transponderNumber of animal.transponderNumber; track transponderNumber) {
                            {{ transponderNumber }}<br/>
                          }
                        </div>
                      }
                      @if (animal.lifeNumber) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.numbers.lifeNumber' | transloco }}</p>
                          <p>{{ animal.lifeNumber }}</p>
                        </div>
                      }
                      @if (animal.petPassportNumber) {
                        <div>
                          <p class="field-title">{{ 'animalAdd.general.numbers.petPassportNumber' | transloco }}</p>
                          <p>{{ animal.petPassportNumber }}</p>
                        </div>
                      }
                      @if (animal.equinePassportNumber) {
                        <div>
                          <p
                            class="field-title">{{ 'animalAdd.general.numbers.equinePassportNumber' | transloco }}</p>
                          <p>{{ animal.equinePassportNumber }}</p>
                        </div>
                      }
                      @if (animal.ringNumber) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.numbers.ringNumber' | transloco }}</p>
                          <p>{{ animal.ringNumber }}</p>
                        </div>
                      }
                      @if (animal.earTag) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.numbers.earTagNumber' | transloco }}</p>
                          <p>{{ animal.earTag }}</p>
                        </div>
                      }
                      @if (animal.tattoo) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.numbers.tattoo' | transloco }}</p>
                          <p>{{ animal.tattoo }}</p>
                        </div>
                      }
                      @if (animal.tattooLocation) {
                        <div>
                          <p class="field-title">{{ 'animalDetails.general.numbers.tattooLocation' | transloco }}</p>
                          <p>{{ animal.tattooLocation }}</p>
                        </div>
                      }
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
                <p-accordion-panel value="1">
                  <p-accordion-header>{{ 'animalDetails.general.specialInformations.headline' | transloco }}</p-accordion-header>
                  @if (animal.specialInformation && animal.specialInformation.length) {
                  <p-accordion-content>
                    <div class="grid gap-2">
                        <div class="col-span-12">
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.specialInformation' | transloco }}</p>
                          <app-editor-field
                            [(ngModel)]="animal.specialInformation"
                            [disabled]="true"
                            [style]="{ border: 'none' }"
                          />
                        </div>
                      </div>
                    </p-accordion-content>
                  }
                  </p-accordion-panel>
              </p-accordion>
            </div>
          </div>
          <div class="grid grid-cols-1 gap-2">
            <div>
              <p-accordion [multiple]="true" [value]="['0']">
                <p-accordion-panel value="0">
                  <p-accordion-header>{{ 'animalDetails.general.websiteInformations.headline' | transloco }}</p-accordion-header>
                  <p-accordion-content>
                    <div class="grid grid-cols-2 gap-2">
                      @if (animal.externalShortDescription) {
                        <div class="col-span-2">
                          <p
                            class="field-title">{{ 'animalDetails.general.websiteInformations.externalShortDescription' | transloco }}</p>
                          <p>{{ animal.externalShortDescription }}</p>
                        </div>
                      }
                      @if (animal.externalDescription) {
                        <div>
                          <p class="field-title">
                            {{ 'animalDetails.general.websiteInformations.externalDescription' | transloco }}
                          </p>
                          <app-editor-field
                            [(ngModel)]="animal.externalDescription"
                            [disabled]="true"
                            [style]="{ border: 'none' }"
                          />
                        </div>
                      }

                      @if (animal.internalDetails.length) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.characteristics.internal' | transloco }}</p>
                          <p>
                            @for (characteristic of animal.internalDetails; track characteristic; let
                                isLast = $last) {
                              <span>
                            {{ 'animal.characteristics.' + getCharacteristicsEnumKey(characteristic) | transloco }}
                                @if (!isLast) {
                                  ,
                                }
                          </span>
                            }
                          </p>
                        </div>
                      }
                      @if (animal.externalDetails.length) {
                        <div>
                          <p
                            class="field-title">{{ 'animalDetails.general.specialInformations.characteristics.external' | transloco }}</p>
                          <p>
                            @for (characteristic of animal.externalDetails; track characteristic; let
                                isLast = $last) {
                              <span>
                            {{ 'animal.characteristics.' + getCharacteristicsEnumKey(characteristic) | transloco }}
                                @if (!isLast) {
                                  ,
                                }
                          </span>
                            }
                          </p>
                        </div>
                      }
                      @if (animal.websiteMetaDescription && animal.websiteMetaDescription.length) {
                        <div>
                          <p class="field-title" for="websiteMetaDescription">
                            {{ 'animalAdd.general.websiteInformations.websiteMetaDescription' | transloco }}
                          </p>
                          <p>{{ animal.websiteMetaDescription }}</p>
                        </div>
                      }
                      @if (animal.websiteMetaTitle?.length) {
                        <div>
                          <p class="field-title" for="websiteMetaTitle">
                            {{ 'animalAdd.general.websiteInformations.websiteMetaTitle' | transloco }}
                          </p>
                          <p>{{ animal.websiteMetaTitle }}</p>
                        </div>
                      }
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
              </p-accordion>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="1">
          @for (pair of pairRows; track (pair.originId ?? 0) + '-' + (pair.whereaboutId ?? 0); let isFirst = $first) {
            <div class="grid grid-cols-2 gap-2 mb-4">
              <div>
                @if (pair.originId != null) {
                  <app-animal-details-origin
                    [animal]="animal"
                    [singleItemId]="pair.originId"
                  />
                }
              </div>
              <div>
                @if (pair.whereaboutId != null) {
                  <app-animal-details-whereabouts
                    [animal]="animal"
                    [singleItemId]="pair.whereaboutId"
                  />
                } @else if (isFirst) {
                  <app-animal-details-whereabouts
                    #masterWhereabouts
                    [animal]="animal"
                    [addModeOnly]="true"
                  />
                }
              </div>
            </div>
          }
        </p-tabpanel>
        <p-tabpanel [value]="2">
          <app-animal-details-gallery [animal]="animal"></app-animal-details-gallery>
          <div class="col-span-12 mt-3">
            <p-message severity="info">
              {{ 'messages.sharePointSync' | transloco }}
            </p-message>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="3">
          <app-animal-details-notes [animal]="animal"></app-animal-details-notes>
        </p-tabpanel>
        <p-tabpanel [value]="4">
          <app-animal-details-timeline #animalDetailsTimelineComponent [animal]="animal"></app-animal-details-timeline>
        </p-tabpanel>
        <p-tabpanel [value]="5">
          <app-animal-details-documents [animal]="animal"></app-animal-details-documents>
        </p-tabpanel>
        <p-tabpanel [value]="6">
          <app-animal-details-medical [animal]="animal" [active]="selectedTabIndex === 6"></app-animal-details-medical>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
    @if (showEditDialog) {
      <app-animal-edit-dialog [animal]="animal"></app-animal-edit-dialog>
    }
    @if (showMoveDialog) {
      <app-animal-move-dialog [animal]="animal"></app-animal-move-dialog>
    }
    @if (showMoveHistoryDialog) {
      <app-animal-move-history-dialog [animal]="animal"></app-animal-move-history-dialog>
    }
  </p-panel>
}

@if (addDialogVisible) {
  <app-animal-add-dialog></app-animal-add-dialog>
}

@if (duplicateAnimalDialogVisible && duplicateOrigin && animal) {
  <app-duplicate-animals
    [animal]="animal"
    [origin]="duplicateOrigin"
    [foundProcessMode]="duplicateFoundMode"
    [foundIncludeOriginal]="false"
    [foundShared]="duplicateFoundShared"
    (closed)="duplicateAnimalDialogVisible = false"
  />
}
